<template>
    <div class="date-picker">

        <app-date-picker-month-selector :position="position"
                                        @change="onMonthChange"
                                        :year="selectorDate.year"
                                        :month="selectorDate.month"
                                        :active="isDateActive" />

        <div class="calendar">

            <div class="days-in-week">
                <div v-for="day in days" class="day-in-week">{{ day }}</div>
            </div>

            <div class="days-in-month">
                <div v-for="row in matrix" class="days-row">
                    <div v-for="day in row"
                         class="day-in-month"
                         :class="{ 'selected': isDayInMonthEqual(day.date),
                        'active': day.active,
                        'selected-path': isDateInsidePath(day.date) }"
                         @click="onItemClick(day)"
                         v-if="day != -1">{{ day.date.getDate() }}</div>
                    <div v-else class="day-in-month"></div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>

    import DatePickerMonthSelector from './DatePickerMonthSelector.vue';

    export default {

        props: {
            selectorDate: {
                type: Object,
                required: true
            },
            position: {
                type: String,
                required: true
            },
            minDate: {
                type: Date,
                default() {
                    return new Date(2010, 0, 1);
                }
            },
            maxDate: {
                type: Date,
                default() {
                    return new Date();
                }
            },
            path: {
                type: Object
            }
        },

        components: {
            appDatePickerMonthSelector: DatePickerMonthSelector
        },

        data() {
            return {
                days: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                matrix: null,
                currentDate: new Date()
            }
        },

        created() {
            this.build();
        },

        watch: {

            selectorDate(value) {
                this.matrix = this.createMonthMatrix();
            }

        },

        computed: {
            isDateActive() {

                let _year = this.selectorDate.year;
                let _month = this.selectorDate.month;

                let maxDate_year = new Date(this.maxDate).getFullYear();
                let maxDate_month = new Date(this.maxDate).getMonth();

                let minDate_year = new Date(this.minDate).getFullYear();
                let minDate_month = new Date(this.minDate).getMonth();

                let isValid = false;

                if (_year < maxDate_year) {
                    if (_year == minDate_year) {
                        isValid = _month > minDate_month;
                    } else if (_year > minDate_year) {
                        isValid = true;
                    }
                } else if (_year == maxDate_year) {
                    isValid = _month < maxDate_month;
                }

                return isValid;
            },
        },

        methods: {

            isDateInsidePath(date) {
                if (this.path && this.path.start && this.path.end) {
                    let pathStart = new Date(this.path.start.getTime()).setHours(0, 0, 0, 0);
                    let pathEnd = new Date(this.path.end.getTime()).setHours(23, 59, 59);
                    return date >= pathStart && date <= pathEnd;
                }
            },

            isDayInMonthEqual(todayDate) {
                var d1 = new Date(todayDate.getTime()).setHours(0, 0, 0, 0);
                var d2 = new Date().setHours(0, 0, 0, 0);
                return d1 == d2;
            },

            build() {
                this.matrix = this.createMonthMatrix();
            },

            createMonthMatrix() {

                let _year = this.selectorDate.year;
                let _month = this.selectorDate.month;

                var numberOfDays = new Date(_year, _month + 1, 0).getDate() + 1;

                var arr = [[]];
                var rowNumber = 0;

                var dayInWeek = new Date(_year, _month, 1).getDay();
                for (var i = 0; i < dayInWeek; i++) {
                    arr[0].push(-1);
                }

                var index = 0;

                let d = new Date();
                let minutes = d.getMinutes();
                let seconds = d.getSeconds();
                let hours = d.getHours();

                for (var i = dayInWeek; i < numberOfDays + dayInWeek - 1; i++) {

                    if (i % 7 == 0) {
                        rowNumber++;
                        arr.push([]);
                    }

                    var value = ++index;

                    let day_date = new Date(new Date(_year, _month, value).setHours(hours, minutes, seconds));

                    arr[rowNumber].push({
                        active: this.isDayActive(day_date),
                        date: day_date
                    });

                }

                var remainingDays = 7 - arr[arr.length - 1].length;
                for (var i = 0; i < remainingDays; i++)
                    arr[arr.length - 1].push(-1);

                return arr;

            },

            onMonthChange() {
                this.$emit('monthChange');
            },

            isDayActive(day_date) {

                //console.log("**date: " + this.date);

                //console.log("date: " + date);
                //console.log("maxDate: " + this.maxDate);

                return day_date <= this.maxDate && day_date >= this.minDate;
            },

            onItemClick(item) {
                let isCurrentDay = this.isDayInMonthEqual(item.date);
                if (item.active || isCurrentDay) {
                    this.$emit('selected', item.date);
                }
            }

        }

    }

</script>

<style lang="scss" scoped>

    .date-picker {
        width: 190px;
        user-select: none;
        .calendar

    {
        margin-top: 10px;
    }

    .days-in-week {
        display: flex;
        height: 25px;
        .day-in-week

    {
        color: #6F6F6F;
        font-weight: bold;
        flex: 1;
        text-align: center;
    }

    }

    .days-in-month {
        flex: 1;
        .days-row

    {
        display: flex;
    }

    .day-in-month {
        flex: 1;
        padding: 3px;
        color: #C4C4C4;
        text-align: center;
        font-size: 15px;
        user-select: none;
    }

        .day-in-month.active {
            cursor: pointer;
            color: #6F6F6F;
        }

        .day-in-month.selected-path {
            background: #E4F2F8;
        }

        .day-in-month.selected {
            cursor: pointer;
            background: #2BA7E5;
            color: white;
        }

    }
    }
</style>



// WEBPACK FOOTER //
// src/components/Common/RangedDatePicker/DatePicker.vue